import IFACE, { EL } from './IFACE.js';
import Hide from '../event/Hide.js';
import Show from '../event/Show.js';
/** An interface for Display driven Events */
export default class Hideable extends IFACE {
    /** A series of Display Related Events and Methods */
    constructor(node) {
        super(node, 'hideable');
    }
    addListeners(node) {
        node.on('hide', () => node.hide());
        node.on('show', () => node.show());
    }
    setMethods(node) {
        /** Hides the element
            @returns {Promise<ThisType>} Promise Chain
        */
        this.methods.hide = () => node.chain(() => {
            node.removeClass('show');
            node.addClass('hide');
        });
        /** Shows the element
            @returns {Promise<ThisType>} Promise Chain
        */
        this.methods.show = () => node.chain(() => {
            node.removeClass('hide');
            node.addClass('show');
        });
    }
}
export { EL, Hide, IFACE, Show };
